import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAppSelector } from "../../hooks/hook";
import { clickType } from "../../constants/constants";
import CreateChannel from "../forms/CreateChannel";
import Settings from "../Settings/Settings";
import Contacts from "../Contacts/Contacts";
import CloseMenu from "./CloseMenu";
import styles from './MenuComponent.module.scss';
import ChannelFullInfoComponent from "../HomePage/ChannelFullInfoComponent";
import UserFullInfoComponent from "../HomePage/UserFullInfoComponent";
const MenuChild = () => {
    const content = useAppSelector(state => state.app.menu.menuChild);
    return (_jsxs("div", { className: styles.barChildContent, children: [_jsx("div", { children: _jsx(CloseMenu, { left: true }) }), content === clickType.CREATE_CHANNEL && _jsx(CreateChannel, {}), content === clickType.SETTINGS && _jsx(Settings, {}), content === clickType.CONTACTS && _jsx(Contacts, {}), content === clickType.SHOW_CHANNEL_INFO && _jsx(ChannelFullInfoComponent, {}), content === clickType.SHOW_USER_INFO && _jsx(UserFullInfoComponent, {})] }));
};
export default MenuChild;
